import { render, staticRenderFns } from "./AppNavigationProjectItem.vue?vue&type=template&id=7eaaf9ed&scoped=true&"
import script from "./AppNavigationProjectItem.vue?vue&type=script&lang=js&"
export * from "./AppNavigationProjectItem.vue?vue&type=script&lang=js&"
import style0 from "./AppNavigationProjectItem.vue?vue&type=style&index=0&id=7eaaf9ed&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eaaf9ed",
  null
  
)

export default component.exports